import React from 'react';
// v2026.08.07.1535 cache buster
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './Login';
import VisualizacaoAnalista from './VisualizacaoAnalista';
import Dashboard from './Dashboard';
import GerenciarLojas from './admin/GerenciarLojas';
import GerenciarLicensa from './admin/GerenciarLicensa';
import FinanceiroAdmin from './admin/FinanceiroAdmin';
import BpsPortal from './BpsPortal';

// Error Boundary global para evitar tela branca
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary capturou erro:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ 
          display: 'flex', flexDirection: 'column', alignItems: 'center', 
          justifyContent: 'center', height: '100vh', background: '#f7fafc',
          fontFamily: 'Roboto, sans-serif', padding: '20px', textAlign: 'center'
        }}>
          <h2 style={{ color: '#e53e3e', marginBottom: '16px' }}>⚠️ Algo deu errado</h2>
          <p style={{ color: '#4a5568', marginBottom: '24px', maxWidth: '400px' }}>
            Ocorreu um erro inesperado. Tente recarregar a página.
          </p>
          <button
            onClick={() => {
              localStorage.removeItem('token');
              localStorage.removeItem('user');
              window.location.href = '/';
            }}
            style={{
              background: '#3182ce', color: 'white', border: 'none',
              padding: '12px 24px', borderRadius: '8px', fontSize: '14px',
              fontWeight: '600', cursor: 'pointer'
            }}
          >
            Recarregar
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

// Componente de proteção de rota
const ProtectedRoute = ({ children, requiredRole }) => {
  const token = localStorage.getItem('token');
  const userData = localStorage.getItem('user');

  if (!token || !userData) {
    return <Navigate to="/" replace />;
  }

  // Verifica se o usuário tem o cargo necessário ou se é super_admin (cargo Admin)
  if (requiredRole) {
    const user = JSON.parse(userData);
    
    // Verifica cargo ou tipo
    const userRole = user.cargo;
    const userType = user.tipo;

    // Se requiredRole incluir 'Admin' e o usuário for super_admin, permite
    if (requiredRole.includes('Admin') && (userType === 'super_admin' || userRole === 'Admin')) {
        return children;
    }

    if (!requiredRole.includes(userRole)) {
      return <Navigate to="/" replace />;
    }
  }

  return children;
};

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/bps" element={<BpsPortal />} />
          <Route path="/pbs" element={<BpsPortal />} />
          
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                <Dashboard 
                  user={JSON.parse(localStorage.getItem('user'))} 
                  onLogout={() => {
                    localStorage.removeItem('token');
                    localStorage.removeItem('user');
                    window.location.href = '/';
                  }}
                />
              </ProtectedRoute>
            } 
          />

          <Route 
            path="/admin/financeiro" 
            element={
              <ProtectedRoute requiredRole={['Admin']}>
                  <FinanceiroAdmin onLogout={() => {
                    localStorage.removeItem('token');
                    localStorage.removeItem('user');
                    window.location.href = '/';
                  }} />
              </ProtectedRoute>
            } 
          />

        {/* Rota de Admin - Gerenciar Lojas */}
        <Route 
          path="/admin/lojas" 
          element={
            <ProtectedRoute requiredRole={['Admin']}>
              <GerenciarLojas onLogout={() => {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                window.location.href = '/';
              }} />
            </ProtectedRoute>
          } 
        />

        {/* Rota de Admin - Gerenciar Licensa */}
        <Route 
          path="/admin/licensa" 
          element={
            <ProtectedRoute requiredRole={['Admin']}>
              <GerenciarLicensa onLogout={() => {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                window.location.href = '/';
              }} />
            </ProtectedRoute>
          } 
        />

        <Route 
          path="/visualizacao-analista"  
          element={
            <ProtectedRoute requiredRole={['Analista', 'Gerente']}>
              <VisualizacaoAnalista onLogout={() => {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                window.location.href = '/';
              }} />
            </ProtectedRoute>
          } 
        />
        {/* Cobranças removido */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
    </ErrorBoundary>
  );
}

export default App;
